import CustomButton from 'components/customButton';
import React from 'react';
interface GroupButtonProps {
  onClearHandler: () => void;
}
const GroupButton = ({onClearHandler}: GroupButtonProps) => {
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <CustomButton
        className="!bg-primary  "
        type="submit"
        title="اعمال فیلتر"
      />
      <CustomButton
        className="!bg-inherit  !text-primary"
        type="button"
        title="انصراف"
        onClick={() => {
          onClearHandler();
        }}
      />
    </div>
  );
};

export default GroupButton;
